import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { until } from '@vueuse/core';

import { useFlagStore } from '@/stores/flag';

export async function visionHubAccessGuard(
  to: RouteLocationNormalized,
): Promise<NavigationGuardReturn> {
  const flagStore = useFlagStore();

  await flagStore.waitForUserFlags;
  if (!flagStore.ready) return { path: '/not-found' };
  await until(() => flagStore.userFlagsReady).toBe(true);
  if (flagStore.flags.visionHub) {
    return true;
  }

  if (to.name === 'vision.tasks.live.community') {
    return {
      name: 'settings.communityAgent',
      params: { brandLabel: to.params.brandLabel },
      query: to.query,
      hash: to.hash,
    };
  }

  return { path: '/not-found' };
}
